// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 351) return "static/chunks/commons-7440df55284e4bdc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"600":"6659a1913be88089","877":"5f605e4511d1d9a2"}[chunkId] + ".js";
};